import { EventEmitter } from '../depsNode.native';
import { EMIT_READY } from '../enum/index';
/**
 * The `Visitor` class represents a unique user within your application. It aids in
 * managing the visitor's data and fetching the corresponding flags for the visitor
 * from the [Flagship platform](https://app.flagship.io/login) .
 */
export class Visitor extends EventEmitter {
    visitorDelegate;
    constructor(visitorDelegate) {
        super();
        this.visitorDelegate = visitorDelegate;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.visitorDelegate.on(EMIT_READY, (err) => {
            this.emit(EMIT_READY, err);
        });
    }
    /**
     * @inheritdoc
     */
    get visitorId() {
        return this.visitorDelegate.visitorId;
    }
    /**
     * @inheritdoc
     */
    set visitorId(v) {
        this.visitorDelegate.visitorId = v;
    }
    /**
     * @inheritdoc
     */
    get anonymousId() {
        return this.visitorDelegate.anonymousId;
    }
    /**
     * @inheritdoc
     */
    get config() {
        return this.visitorDelegate.config;
    }
    /**
     * @inheritdoc
     */
    get context() {
        return this.visitorDelegate.context;
    }
    /**
     * @inheritdoc
     */
    get fetchStatus() {
        return this.visitorDelegate.fetchStatus;
    }
    /**
     * @inheritdoc
     */
    get hasConsented() {
        return this.visitorDelegate.hasConsented;
    }
    /**
     * @inheritdoc
     */
    setConsent(hasConsented) {
        this.visitorDelegate.setConsent(hasConsented);
    }
    updateContext(context, value) {
        this.visitorDelegate.updateContext(context, value);
    }
    /**
     * @inheritdoc
     */
    clearContext() {
        this.visitorDelegate.clearContext();
    }
    /**
     * @inheritdoc
     */
    getFlag(key) {
        return this.visitorDelegate.getFlag(key);
    }
    /**
     * @inheritdoc
     */
    getFlags() {
        return this.visitorDelegate.getFlags();
    }
    /**
     * @inheritdoc
     */
    fetchFlags() {
        return this.visitorDelegate.fetchFlags();
    }
    sendHit(hit) {
        return this.visitorDelegate.sendHit(hit);
    }
    sendHits(hits) {
        return this.visitorDelegate.sendHits(hits);
    }
    /**
     * @inheritdoc
     */
    authenticate(visitorId) {
        this.visitorDelegate.authenticate(visitorId);
    }
    /**
     * @inheritdoc
     */
    unauthenticate() {
        this.visitorDelegate.unauthenticate();
    }
}
